// extracted by mini-css-extract-plugin
export var callCard = "_pq-0";
export var callMessageButton = "_pq-1";
export var helpIcon = "_pq-3";
export var helpIconContainer = "_pq-4";
export var verticalDivider = "_pq-2";